import { redirect } from "@tanstack/react-router";
import { useAuthStore } from "@/stores";

// TanStack Router beforeLoad helpers. Both are ASYNC because the store starts
// empty on every cold load / hot-reload — calling sync would always read
// `isAuthenticated=false` and bounce, even when the HttpOnly cookies are
// still valid. Awaiting hydrate first lets `/api/auth/me` rehydrate the
// session via cookie before we decide whether to redirect.
//
// Usage in route file:
//   beforeLoad: ({ location }) => requireAuth(location.href),

async function ensureHydrated(): Promise<void> {
  const store = useAuthStore.getState();
  if (store.isInitialized || store.isLoading) return;
  await store.hydrate();
}

export async function requireAuth(currentHref: string): Promise<void> {
  await ensureHydrated();
  if (!useAuthStore.getState().isAuthenticated) {
    throw redirect({
      to: "/signin",
      search: { from: currentHref },
    });
  }
}

// For "must NOT be authed" pages (signin/signup/etc). Redirects authed users
// home so reload of /signin while logged in lands at /.
export async function requireGuest(): Promise<void> {
  await ensureHydrated();
  if (useAuthStore.getState().isAuthenticated) {
    throw redirect({ to: "/" });
  }
}
